import { Component, computed } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { VehicleRoadWorthyCheckRecordModel } from '../../../models/vehicle-road-worthy-check-record.model';
import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { BaseSummarySectionComponent } from '../../../../../../shared/base-classes/sections/base-summary-section.component';
import { ExpiresAtPillComponent } from 'app/shared/components/expires-at-pill/expires-at-pill.component';
import { VehicleLinkCardComponent } from '../../../../vehicles/components/vehicle-link-card/vehicle-link-card.component';
import { DateRangePillComponent } from 'app/shared/components/date-range-pill/date-range-pill.component';
import { SummaryItemComponent } from '../../../../../../../shared/components/summary-item/summary-item.component';

@Component({
	selector: 'app-vehicle-road-worthy-checks-summary',
	templateUrl: 'vehicle-road-worthy-checks-summary.component.html',
	imports: [
		ReactiveFormsModule,
		SectionWrapperComponent,
		ExpiresAtPillComponent,
		VehicleLinkCardComponent,
		DateRangePillComponent,
		SummaryItemComponent,
	],
})
export class VehicleRoadWorthyChecksSummaryComponent extends BaseSummarySectionComponent<VehicleRoadWorthyCheckRecordModel> {
	protected _skipCount: number = 0;

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			tags: [null],
		});
	}

	isoDateFrom = computed(() =>
		new Date(this.recordData().startsAt).toISOString(),
	);
	isoDateTo = computed(() => new Date(this.recordData().endsAt).toISOString());

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			tags: this.recordData().tags,
		};
		this.detailsForm.setValue(detailsFormData);
	}

	protected _mapFormToModel(): Partial<VehicleRoadWorthyCheckRecordModel> {
		return {
			tags: this.detailsForm.value.tags,
		};
	}
}
